(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  var data = JSON.parse(document.getElementById('nr-product-json').textContent);
  var variants = data.variants;
  var selectedOptions = [];

  function initOptions() {
    document.querySelectorAll('.nr-option__values').forEach(function (group) {
      var idx = parseInt(group.dataset.optionIndex);
      var active = group.querySelector('.nr-option__btn.is-selected');
      selectedOptions[idx] = active ? active.dataset.value : null;
    });
  }

  function findVariant() {
    return variants.find(function (v) {
      return v.options.every(function (o, i) { return o === selectedOptions[i]; });
    });
  }

  function formatMoney(cents) {
    return (window.Shopify && Shopify.formatMoney)
      ? Shopify.formatMoney(cents)
      : '$' + (cents / 100).toFixed(2);
  }

  function updatePrice(v) {
    var el = document.getElementById('nr-price');
    if (!el || !v) return;
    if (v.compare_at_price && v.compare_at_price > v.price) {
      el.innerHTML = '<s class="nr-price--compare">' + formatMoney(v.compare_at_price) + '</s>'
        + '<span class="nr-price--sale">' + formatMoney(v.price) + '</span>';
    } else {
      el.innerHTML = '<span class="nr-price">' + formatMoney(v.price) + '</span>';
    }
  }

  function updateATC(v) {
    var btn = document.getElementById('nr-atc');
    if (!btn) return;
    var available = v && v.available;
    btn.disabled = !available;
    btn.setAttribute('aria-disabled', available ? 'false' : 'true');
    btn.textContent = available ? 'Add to Cart' : 'Sold Out';
  }

  function updateVariantInput(v) {
    var input = document.getElementById('nr-variant-id');
    if (input && v) input.value = v.id;
  }

  function updateImage(v) {
    if (!v || !v.featured_image) return;
    var img = document.getElementById('nr-featured-img');
    if (!img) return;
    img.style.opacity = '0';
    setTimeout(function () {
      img.src = v.featured_image.src;
      img.style.opacity = '1';
    }, 160);
  }

  document.querySelectorAll('.nr-option__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var idx = parseInt(btn.dataset.optionIndex);
      var group = document.querySelector('.nr-option__values[data-option-index="' + idx + '"]');
      group.querySelectorAll('.nr-option__btn').forEach(function (b) {
        b.classList.remove('is-selected');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('is-selected');
      btn.setAttribute('aria-pressed', 'true');
      var label = document.getElementById('nr-option-val-' + idx);
      if (label) label.textContent = ': ' + btn.dataset.value;
      selectedOptions[idx] = btn.dataset.value;
      var v = findVariant();
      updatePrice(v);
      updateATC(v);
      updateVariantInput(v);
      updateImage(v);
    });
  });

  document.querySelectorAll('.nr-qty__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var input = document.getElementById('nr-qty');
      var current = parseInt(input.value) || 1;
      input.value = btn.dataset.action === 'plus' ? current + 1 : Math.max(1, current - 1);
    });
  });

  document.querySelectorAll('.nr-product__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      document.querySelectorAll('.nr-product__thumb').forEach(function (t) {
        t.classList.remove('is-active');
      });
      thumb.classList.add('is-active');
      var img = document.getElementById('nr-featured-img');
      img.style.opacity = '0';
      setTimeout(function () {
        img.src = thumb.dataset.src;
        img.alt = thumb.dataset.alt;
        img.style.opacity = '1';
      }, 160);
    });
  });

  initOptions();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["onx-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  var data = JSON.parse(document.getElementById('onx-product-json').textContent);
  var variants = data.variants;
  var selectedOptions = [];

  function initOptions() {
    document.querySelectorAll('.onx-option__btns').forEach(function (group) {
      var idx = parseInt(group.dataset.optionIndex);
      var active = group.querySelector('.onx-option__btn.is-active');
      selectedOptions[idx] = active ? active.dataset.value : null;
    });
  }

  function findVariant() {
    return variants.find(function (v) {
      return v.options.every(function (o, i) { return o === selectedOptions[i]; });
    });
  }

  function fmt(cents) {
    return (window.Shopify && Shopify.formatMoney) ? Shopify.formatMoney(cents) : '$' + (cents / 100).toFixed(2);
  }

  function updatePrice(v) {
    var el = document.getElementById('onx-price');
    if (!el || !v) return;
    el.innerHTML = (v.compare_at_price && v.compare_at_price > v.price)
      ? '<s class="onx-price--compare">' + fmt(v.compare_at_price) + '</s><span class="onx-price--sale">' + fmt(v.price) + '</span>'
      : '<span class="onx-price__main">' + fmt(v.price) + '</span>';
  }

  function updateATC(v) {
    var btn = document.getElementById('onx-atc');
    if (!btn) return;
    var ok = v && v.available;
    btn.disabled = !ok;
    btn.setAttribute('aria-disabled', ok ? 'false' : 'true');
    btn.textContent = ok ? 'Add to Cart' : 'Sold Out';
  }

  function updateInput(v) {
    var inp = document.getElementById('onx-vid');
    if (inp && v) inp.value = v.id;
  }

  function updateImg(v) {
    if (!v || !v.featured_image) return;
    var img = document.getElementById('onx-img');
    if (!img) return;
    img.style.opacity = '0';
    setTimeout(function () { img.src = v.featured_image.src; img.style.opacity = '1'; }, 160);
  }

  document.querySelectorAll('.onx-option__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var idx = parseInt(btn.dataset.optionIndex);
      var group = document.querySelector('.onx-option__btns[data-option-index="' + idx + '"]');
      group.querySelectorAll('.onx-option__btn').forEach(function (b) {
        b.classList.remove('is-active');
        b.setAttribute('aria-pressed', 'false');
      });
      btn.classList.add('is-active');
      btn.setAttribute('aria-pressed', 'true');
      var lbl = document.getElementById('onx-ov-' + idx);
      if (lbl) lbl.textContent = ': ' + btn.dataset.value;
      selectedOptions[idx] = btn.dataset.value;
      var v = findVariant();
      updatePrice(v);
      updateATC(v);
      updateInput(v);
      updateImg(v);
    });
  });

  document.querySelectorAll('.onx-qty__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var inp = document.getElementById('onx-qty');
      var n = parseInt(inp.value) || 1;
      inp.value = btn.dataset.action === 'plus' ? n + 1 : Math.max(1, n - 1);
    });
  });

  document.querySelectorAll('.onx-gallery__thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      document.querySelectorAll('.onx-gallery__thumb').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      var img = document.getElementById('onx-img');
      img.style.opacity = '0';
      setTimeout(function () { img.src = thumb.dataset.src; img.alt = thumb.dataset.alt; img.style.opacity = '1'; }, 160);
    });
  });

  initOptions();
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["premium-coffee-product"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* ── Data ── */
  var raw   = document.getElementById('nrp-product-data');
  if (!raw) return;
  var data  = JSON.parse(raw.textContent);
  var variants = data.variants;
  var selectedOptions = [];
  var stickyQty = 1;
  var subscribeMode = false;

  /* ── Helpers ── */
  function fmt(cents) {
    return (window.Shopify && Shopify.formatMoney)
      ? Shopify.formatMoney(cents)
      : '$' + (cents / 100).toFixed(2);
  }

  function findVariant() {
    return variants.find(function (v) {
      return v.options.every(function (o, i) { return o === selectedOptions[i]; });
    });
  }

  function initOptions() {
    document.querySelectorAll('[data-option-index]').forEach(function (group) {
      var idx = parseInt(group.dataset.optionIndex);
      var active = group.querySelector('.is-active');
      selectedOptions[idx] = active ? active.dataset.value : null;
    });
    /* Single default variant: no option buttons exist, pre-populate from first variant */
    if (selectedOptions.length === 0 && variants.length > 0) {
      variants[0].options.forEach(function (opt, i) { selectedOptions[i] = opt; });
    }
  }

  /* ── Price update ── */
  function updatePrice(v) {
    if (!v) return;
    var price = v.price;

    var priceEl = document.getElementById('nrp-price');
    if (priceEl) {
      if (v.compare_at_price && v.compare_at_price > v.price) {
        priceEl.innerHTML = '<s class="nrp-price__compare">' + fmt(v.compare_at_price) + '</s>'
          + '<span class="nrp-price__sale">' + fmt(price) + '</span>';
      } else {
        priceEl.innerHTML = '<span class="nrp-price__main">' + fmt(price) + '</span>';
      }
    }

    var oneTimeEl = document.getElementById('nrp-onetime-price');
    if (oneTimeEl) oneTimeEl.textContent = fmt(v.price);

    var stickyPrice = document.getElementById('nrp-sticky-price');
    if (stickyPrice) stickyPrice.textContent = fmt(price);
  }

  /* ── ATC state update ── */
  function updateATC(v) {
    ['nrp-atc', 'nrp-sticky-atc'].forEach(function (id) {
      var btn = document.getElementById(id);
      if (!btn) return;
      var ok = v && v.available;
      btn.disabled = !ok;
      btn.textContent = ok ? 'Add to Cart' : 'Sold Out';
    });
  }

  function updateVariantInput(v) {
    var inp = document.getElementById('nrp-variant-id');
    if (inp && v) inp.value = v.id;
  }

  function updateMainImage(v) {
    if (!v || !v.featured_image) return;
    var img = document.getElementById('nrp-main-img');
    if (!img) return;
    img.style.opacity = '0';
    setTimeout(function () {
      img.src = v.featured_image.src;
      img.style.opacity = '1';
    }, 200);
    var stickyImg = document.getElementById('nrp-sticky-img');
    if (stickyImg) stickyImg.src = v.featured_image.src;
  }

  function updateVariantLabel(v) {
    var el = document.getElementById('nrp-sticky-variant');
    if (el && v) el.textContent = v.title === 'Default Title' ? '' : v.title;
  }

  function syncAll() {
    var v = findVariant();
    updatePrice(v);
    updateATC(v);
    updateVariantInput(v);
    updateMainImage(v);
    updateVariantLabel(v);

    /* selling plan */
    var spInput = document.getElementById('nrp-selling-plan');
    if (spInput) {
      if (subscribeMode && data.selling_plan_groups && data.selling_plan_groups.length > 0) {
        var plans = data.selling_plan_groups[0].selling_plans;
        if (plans && plans.length > 0) spInput.value = plans[0].id;
      } else {
        spInput.value = '';
      }
    }
  }

  /* ── Option buttons ── */
  document.querySelectorAll('[data-option-index]').forEach(function (group) {
    group.querySelectorAll('[data-value]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var idx = parseInt(btn.dataset.optionIndex);
        var container = document.querySelector('[data-option-index="' + idx + '"]');
        container.querySelectorAll('[data-value]').forEach(function (b) {
          b.classList.remove('is-active');
          b.setAttribute('aria-pressed', 'false');
        });
        btn.classList.add('is-active');
        btn.setAttribute('aria-pressed', 'true');
        var lbl = document.getElementById('nrp-opt-' + idx);
        if (lbl) lbl.textContent = ': ' + btn.dataset.value;
        selectedOptions[idx] = btn.dataset.value;
        syncAll();
      });
    });
  });

  /* ── Quantity controls ── */
  function handleQty(action, inputId, displayId) {
    var inp = document.getElementById(inputId);
    if (inp) {
      var n = parseInt(inp.value) || 1;
      inp.value = action === 'plus' ? n + 1 : Math.max(1, n - 1);
    }
    if (displayId) {
      var disp = document.getElementById(displayId);
      if (disp) {
        var cur = parseInt(disp.textContent) || 1;
        var next = action.includes('plus') ? cur + 1 : Math.max(1, cur - 1);
        disp.textContent = next;
        stickyQty = next;
      }
    }
  }

  document.querySelectorAll('.nrp-qty__btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      handleQty(btn.dataset.action, 'nrp-qty', null);
    });
  });

  document.querySelectorAll('.nrp-sticky__qty-btn').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var action = btn.dataset.action;
      handleQty(action === 'sticky-plus' ? 'plus' : 'minus', 'nrp-qty', 'nrp-sticky-qty');
    });
  });

  /* ── Subscription toggle ── */
  document.querySelectorAll('.nrp-purchase__card').forEach(function (card) {
    card.addEventListener('click', function () {
      document.querySelectorAll('.nrp-purchase__card').forEach(function (c) {
        c.classList.remove('is-active');
        c.setAttribute('aria-checked', 'false');
      });
      card.classList.add('is-active');
      card.setAttribute('aria-checked', 'true');
      subscribeMode = card.dataset.type === 'subscribe';
      syncAll();
    });
  });

  /* ── Gallery ── */
  var mediaList = [];
  document.querySelectorAll('.nrp-gallery__thumb').forEach(function (thumb) {
    mediaList.push({ src: thumb.dataset.src, alt: thumb.dataset.alt });
    thumb.addEventListener('click', function () {
      document.querySelectorAll('.nrp-gallery__thumb').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      var img = document.getElementById('nrp-main-img');
      if (!img) return;
      img.style.opacity = '0';
      setTimeout(function () { img.src = thumb.dataset.src; img.alt = thumb.dataset.alt; img.style.opacity = '1'; }, 180);
    });
  });

  var currentIdx = 0;
  function navGallery(dir) {
    if (!mediaList.length) return;
    currentIdx = (currentIdx + dir + mediaList.length) % mediaList.length;
    var img = document.getElementById('nrp-main-img');
    if (img) {
      img.style.opacity = '0';
      setTimeout(function () { img.src = mediaList[currentIdx].src; img.alt = mediaList[currentIdx].alt; img.style.opacity = '1'; }, 180);
    }
    var thumbs = document.querySelectorAll('.nrp-gallery__thumb');
    thumbs.forEach(function (t, i) {
      t.classList.toggle('is-active', i === currentIdx);
    });
  }

  var prevBtn = document.getElementById('nrp-prev');
  var nextBtn = document.getElementById('nrp-next');
  if (prevBtn) prevBtn.addEventListener('click', function () { navGallery(-1); });
  if (nextBtn) nextBtn.addEventListener('click', function () { navGallery(1); });

  /* ── Sticky cart visibility ── */
  var heroInfo = document.getElementById('nrp-hero-info');
  var stickyBar = document.getElementById('nrp-sticky');

  if (heroInfo && stickyBar) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        stickyBar.classList.toggle('is-visible', !entry.isIntersecting);
        stickyBar.setAttribute('aria-hidden', entry.isIntersecting ? 'true' : 'false');
      });
    }, { threshold: 0.1 });
    observer.observe(heroInfo);
  }

  /* ── Sticky ATC submit ── */
  var stickyAtc = document.getElementById('nrp-sticky-atc');
  if (stickyAtc) {
    stickyAtc.addEventListener('click', function () {
      var vid = document.getElementById('nrp-variant-id');
      var sp  = document.getElementById('nrp-selling-plan');
      if (!vid) return;
      var body = { items: [{ id: parseInt(vid.value), quantity: stickyQty }] };
      if (sp && sp.value) body.items[0].selling_plan = parseInt(sp.value);
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(body)
      }).then(function () {
        stickyAtc.textContent = 'Added ✓';
        setTimeout(function () { stickyAtc.textContent = 'Add to Cart'; }, 2000);
      }).catch(function () {
        stickyAtc.textContent = 'Error — try again';
        setTimeout(function () { stickyAtc.textContent = 'Add to Cart'; }, 2500);
      });
    });
  }

  /* ── Recommended products ── */
  var recsTrack = document.getElementById('nrp-recs-track');
  if (recsTrack && data.id) {
    fetch('/recommendations/products.json?product_id=' + data.id + '&limit=6')
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d.products || !d.products.length) {
          recsTrack.innerHTML = '';
          return;
        }
        recsTrack.innerHTML = d.products.map(function (p) {
          var img = p.images && p.images[0] ? p.images[0].src : '';
          var price = p.variants && p.variants[0] ? '$' + (p.variants[0].price / 100).toFixed(2) : '';
          return '<a href="' + p.url + '" class="nrp-rec-card">'
            + (img ? '<img src="' + img + '" alt="' + (p.title || '') + '" class="nrp-rec-card__img" loading="lazy">' : '')
            + '<div class="nrp-rec-card__body">'
            + '<p class="nrp-rec-card__title">' + (p.title || '') + '</p>'
            + '<p class="nrp-rec-card__price">' + price + '</p>'
            + '</div></a>';
        }).join('');
      })
      .catch(function () { recsTrack.innerHTML = ''; });
  }

  /* ── Init ── */
  initOptions();
  syncAll();
})();

  } catch(e) { console.error(e); }
})();
})();
